import axios from 'axios';
import { jwtDecode } from 'jwt-decode';

const currentProtocol = window.location.protocol;
const API_BASE_URL =
  (currentProtocol === 'http:'
    ? process.env.REACT_APP_API_BASE_URL_IP
    : process.env.REACT_APP_API_BASE_URL_DOMAIN) ??
  process.env.REACT_APP_API_BASE_URL;

// 创建带拦截器的http实例和不带拦截器的rawAxios实例
const http = axios.create({ baseURL: API_BASE_URL });
const rawAxios = axios.create({ baseURL: API_BASE_URL });

// Token检查工具函数
const isTokenExpired = (token) => {
  try {
    const decoded = jwtDecode(token);
    return decoded.exp < Date.now() / 1000;
  } catch (error) {
    console.error('Token解析错误:', error);
    return true;
  }
};

const shouldRefreshToken = (token) => {
  try {
    const decoded = jwtDecode(token);
    const remainingTime = decoded.exp - Date.now() / 1000;

    return remainingTime < 3600;
  } catch (error) {
    console.error('Token解析错误:', error);
    return true;
  }
};

// Token刷新队列管理
let isRefreshing = false;
let refreshSubscribers = [];

const subscribeTokenRefresh = (cb) => {
  refreshSubscribers.push(cb);
};

const onTokenRefreshed = (newToken) => {
  refreshSubscribers.forEach((cb) => cb(newToken));
  refreshSubscribers = [];
};

// 请求拦截器
http.interceptors.request.use(
  async (config) => {
    if (
      config.url.includes('/user/login') ||
      config.url.includes('/user/refresh-token') ||
      config.url.includes('/user/publicKey')
    ) {
      return config;
    }

    const accessToken = sessionStorage.getItem('token');
    const refreshToken = sessionStorage.getItem('refreshToken');
    const deviceId = sessionStorage.getItem('deviceId');

    if (!accessToken) {
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('refreshToken');
      sessionStorage.removeItem('deviceId');
      sessionStorage.removeItem('role_id');
      sessionStorage.removeItem('userid');
      sessionStorage.removeItem('companyName');
      sessionStorage.removeItem('role_name');
      window.location.href = '/login';
    }

    // Token过期处理
    if (isTokenExpired(accessToken)) {
      window.alert('登录已过期，请重新登录');
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('refreshToken');
      sessionStorage.removeItem('deviceId');
      sessionStorage.removeItem('role_id');
      window.location.href = '/login';
    }

    if (shouldRefreshToken(accessToken) && refreshToken && deviceId) {
      if (!isRefreshing) {
        isRefreshing = true;
        try {
          const response = await rawAxios.post('/videoapi/user/refresh-token', {
            refreshToken,
            deviceId,
          });

          const newToken = response.data.token;
          const newRefreshToken = response.data.refreshToken;
          sessionStorage.setItem('token', newToken);
          sessionStorage.setItem('refreshToken', newRefreshToken);
          http.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;

          config.headers['Authorization'] = `Bearer ${newToken}`;
          isRefreshing = false;
          onTokenRefreshed(newToken);
        } catch (error) {
          console.error('刷新Token失败:', error);
          sessionStorage.removeItem('token');
          sessionStorage.removeItem('refreshToken');
          sessionStorage.removeItem('deviceId');
          sessionStorage.removeItem('role_id');
          window.location.href = '/login';
          isRefreshing = false;
          return config;
        }
      } else {
        return new Promise((resolve) => {
          subscribeTokenRefresh((newToken) => {
            config.headers['Authorization'] = `Bearer ${newToken}`;
            resolve(config);
          });
        });
      }
    } else {
      config.headers['Authorization'] = `Bearer ${accessToken}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default http;
